<script>
  import { location, push } from 'svelte-spa-router'
  import active from 'svelte-spa-router/active'

  import Icon from 'svelte-icon'
  import check from '$assets/svg/checkbox.svg'
  import tool from '$assets/svg/tool.svg'

  const size = "32px"
</script>

<main id="sidebar">
  <!-- <div class="navitem" use:active href="/status" on:click={() => push('/status')}> -->
  <!--   <Icon class="icon" data={check} stroke="black" {size} /> -->
  <!--   <span class="label">Status</span> -->
  <!-- </div> -->
  <div class="navitem" use:active href="/configs" on:click={() => push('/')}>
    <Icon class="icon" data={tool} stroke="black" {size} />
    <span class="label">Configs</span>
  </div>
</main>

<style lang="scss">
  @import "src/variables.scss";

  :global(.active) {
    border-left: 5px solid $accent !important;
  }

  #sidebar {
    width: 3vw;
    height: 95vh;
    position: fixed;
    top: 5vh;
    left: 0;
    background-color: white;
    transition: width .25s;

    .navitem {
      width: 3vw;
      height: 3vw;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;

      &:hover {
        background-color: $gray3;
      }

      .label {
        display: none;
        color: $gray10;
        font-size: 1.5em;
      }

    }
  }
</style>
